// extracted by mini-css-extract-plugin
module.exports =  {"label":"I0ghVzmSh0ljVSWl9W1I"};